import {call, delay, put, race, select, take, takeEvery} from 'redux-saga/effects';
import {MODEL_CONFIGS_CANCEL_FETCH, MODEL_CONFIGS_FETCH, MODEL_CONFIGS_RETRY_FETCH} from './constants';
import app from '../../helpers/app';
import {IListConfig} from '../../@interfaces/components/List/IListConfig';
import {IFormConfig} from '../../@interfaces/components/Form/IFormConfig';
import {fetchModelConfig, saveModelConfigError, setModelConfigs} from './actions';
import {IReduxAction, IReduxModelConfigsState, IReduxStoreState} from '../../@interfaces';
import config from '../../helpers/config';
import {now, parseDate} from '../../helpers/dates';

function* fetch(action: any) {
    const controllerName = action.payload;

    try {
        const configs: { 'list-config': IListConfig, 'form-config': IFormConfig } = yield call(() => {
            const baseModelName = app('names-resolver').apiRoutes.getDefaultBaseModelName();

            return app('http').route(`${baseModelName}.configs`, undefined, {
                body: {'controller-name': controllerName}
            });
        });

        yield put(setModelConfigs(controllerName, configs));
    } catch (error: any) {
        yield put(saveModelConfigError(action.payload, error));

        const lastError: IReduxModelConfigsState['errors'][string] | null = yield select(
            (state: IReduxStoreState) => state.modelConfigs.errors[controllerName] ?? null
        );
        if (!lastError || lastError.attempts < config('client.failed-request.max-attempts', 10)) {
            if (lastError) {
                yield delay(
                    parseDate(lastError.lastAttemptAt).add(
                        config('client.failed-request.retry-timeout-in-seconds', 15),
                        'second'
                    ).diff(now())
                );
            }

            yield put(fetchModelConfig(action.payload));
        }
    }
}

export function* fetchModelConfigSaga() {
    yield takeEvery([MODEL_CONFIGS_FETCH, MODEL_CONFIGS_RETRY_FETCH], function* (action: any) {
        yield race([
            call(fetch, action),
            take(({type, payload}: IReduxAction): boolean => {
                return type === MODEL_CONFIGS_CANCEL_FETCH && payload === action.payload;
            }),
        ]);
    });
}
